var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"main","position":"bottom left","classes":"strategy-notification"}}),_c('notifications',{attrs:{"group":"strategy","position":"bottom center","classes":"strategy-notification"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }